module.exports = __webpack_public_path__ + "img/xx.95b68137.gif";